import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import cookiesStore from '../../store/cookiesStore';
import { LOCALES } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import MultiLanguageInput from '~/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import './style.scss';

const CookiesTitleInput: FC = observer((): ReactElement => {
  const { isFirstLoading, cookies, validation } = cookiesStore;

  const onTitleChanged = useCallback(
    (value: string, locale: LOCALES) => {
      cookiesStore.changeCookiesHandler({ title: { ...cookiesStore.cookies.title, [locale]: value } });
    },
    [cookiesStore.cookies.title]
  );

  return (
    <div className="mb-4">
      {isFirstLoading ? (
        <Skeleton width="100%" height={61} style={{ borderRadius: 12 }} />
      ) : (
        <MultiLanguageInput
          enText={cookies.title.en}
          arText={cookies.title.ar}
          validation={validation.title}
          onChangeValue={onTitleChanged}
          required
          placeholder={`${localeStore.t('title')} *`}
          maxLength={250}
          className="cookies-title-input"
        />
      )}
    </div>
  );
});

export default CookiesTitleInput;
